import { render } from "./FormForgotPassword.vue?vue&type=template&id=67549202&scoped=true"
import script from "./FormForgotPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./FormForgotPassword.vue?vue&type=script&setup=true&lang=js"

import "./FormForgotPassword.vue?vue&type=style&index=0&id=67549202&lang=scss&scoped=true"
import "./FormForgotPassword.vue?vue&type=style&index=1&id=67549202&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67549202"],['__file',"src/views/auth/FormForgotPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67549202"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67549202', __exports__)) {
    api.reload('67549202', __exports__)
  }
  
  module.hot.accept("./FormForgotPassword.vue?vue&type=template&id=67549202&scoped=true", () => {
    api.rerender('67549202', render)
  })

}


export default __exports__